// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sgWEhPVF4ALjeWs19KCt {
    display: none;
    cursor: pointer;
    justify-content: center;
    margin-bottom: 10px;
}

.nG3jNO55lxa54pZjmBbS {
    width: 100%;
    text-align: center;
    display: block;
    position: relative;
    justify-content: center;
}

.nG3jNO55lxa54pZjmBbS img {
    max-width: 100%;
    height: 100%;
    object-fit: contain;
    background-repeat: no-repeat;
}

.uLg9nVE1h5WfjkCUiJ_E {
    height: 50px;
    width: 100px;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.uLg9nVE1h5WfjkCUiJ_E i {
    color: #ffffff;
    font-size: 35px;
}

.HVKd9mnIdMBmxdrtmt7p {
    display: flex;
    flex-direction: row;
}

.EMNzr121ofqP5SRr7WwS {
    position: absolute;
    right: 0;
    margin-top: 15px;
    margin-right: 15px;
}

.HVKd9mnIdMBmxdrtmt7p img {
    max-width: 75px;
    max-height: 75px;
    object-fit: cover;
    background-repeat: no-repeat;
    margin-right: 5px;
    display: none;
}

.OaWZyDUgIarf3DqU8Yqz {
    display: flex;
    flex-direction: column;
    padding: 5px;
    height: 100%;
    width: 100%;
}

.w_hjGIJwVnYAhaDsVpNe img{
    display: flex;
    position: absolute;
    right: 15px;
}

.GMRH86bE1L4JNIKCpY6g {
    width: 100%;
    height: 25px;
    max-height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    color: #212121;
    margin: 0;
}

.ATz7wKXoxUrjxF7296VA {
    width: 100%;
    height: auto;
    max-height: 20px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #757575;
    margin: 0;
}

.qIByXwRPwFbaHNvyhqHv {
    width: 95%;
    height: 20px;
    text-decoration: underline;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #0000ee;
    margin: 0;
}

.qfefmCY9CF9v93JrpNW0 {
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: auto;
}
/* For large screen */
@media only screen and (min-width: 1400px) {
    .nG3jNO55lxa54pZjmBbS {
        height: 300px;
    }
}

@media only screen and (min-width: 600px) {
    /* For desktop: */
    .uLg9nVE1h5WfjkCUiJ_E {
        background-color: rgba(255, 0, 0, 0.8);
    }

    .qIByXwRPwFbaHNvyhqHv {
        font-size: 16px;
    }

    .w_hjGIJwVnYAhaDsVpNe img{
        right: 45px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/form/css/question-attachment.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA,qBAAqB;AACrB;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;QACI,sCAAsC;IAC1C;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".question_attachment_container {\n    display: none;\n    cursor: pointer;\n    justify-content: center;\n    margin-bottom: 10px;\n}\n\n.question_attachment {\n    width: 100%;\n    text-align: center;\n    display: block;\n    position: relative;\n    justify-content: center;\n}\n\n.question_attachment img {\n    max-width: 100%;\n    height: 100%;\n    object-fit: contain;\n    background-repeat: no-repeat;\n}\n\n.question_attachment_video_icon {\n    height: 50px;\n    width: 100px;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: none;\n    justify-content: center;\n    align-items: center;\n    border-radius: 12px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.question_attachment_video_icon i {\n    color: #ffffff;\n    font-size: 35px;\n}\n\n.question_attachment_web_container {\n    display: flex;\n    flex-direction: row;\n}\n\n.question_attachment_close {\n    position: absolute;\n    right: 0;\n    margin-top: 15px;\n    margin-right: 15px;\n}\n\n.question_attachment_web_container img {\n    max-width: 75px;\n    max-height: 75px;\n    object-fit: cover;\n    background-repeat: no-repeat;\n    margin-right: 5px;\n    display: none;\n}\n\n.question_attachment_text_container {\n    display: flex;\n    flex-direction: column;\n    padding: 5px;\n    height: 100%;\n    width: 100%;\n}\n\n.question_attachment_web_close img{\n    display: flex;\n    position: absolute;\n    right: 15px;\n}\n\n.question_attachment_title {\n    width: 100%;\n    height: 25px;\n    max-height: 50px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 18px;\n    color: #212121;\n    margin: 0;\n}\n\n.question_attachment_description {\n    width: 100%;\n    height: auto;\n    max-height: 20px;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #757575;\n    margin: 0;\n}\n\n.question_attachment_url {\n    width: 95%;\n    height: 20px;\n    text-decoration: underline;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #0000ee;\n    margin: 0;\n}\n\n.video_file {\n    object-fit: contain;\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n    height: auto;\n}\n/* For large screen */\n@media only screen and (min-width: 1400px) {\n    .question_attachment {\n        height: 300px;\n    }\n}\n\n@media only screen and (min-width: 600px) {\n    /* For desktop: */\n    .question_attachment_video_icon {\n        background-color: rgba(255, 0, 0, 0.8);\n    }\n\n    .question_attachment_url {\n        font-size: 16px;\n    }\n\n    .question_attachment_web_close img{\n        right: 45px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"question_attachment_container": `sgWEhPVF4ALjeWs19KCt`,
	"question_attachment": `nG3jNO55lxa54pZjmBbS`,
	"question_attachment_video_icon": `uLg9nVE1h5WfjkCUiJ_E`,
	"question_attachment_web_container": `HVKd9mnIdMBmxdrtmt7p`,
	"question_attachment_close": `EMNzr121ofqP5SRr7WwS`,
	"question_attachment_text_container": `OaWZyDUgIarf3DqU8Yqz`,
	"question_attachment_web_close": `w_hjGIJwVnYAhaDsVpNe`,
	"question_attachment_title": `GMRH86bE1L4JNIKCpY6g`,
	"question_attachment_description": `ATz7wKXoxUrjxF7296VA`,
	"question_attachment_url": `qIByXwRPwFbaHNvyhqHv`,
	"video_file": `qfefmCY9CF9v93JrpNW0`
};
export default ___CSS_LOADER_EXPORT___;
